import React from "react";

function CriticalAbout() {
    return (
        <section className="critical-about" aria-hidden="true">
            <div>
                <div className="critical-about-title">
                    <div>
                        <h1>
                            xsiadron<span>&nbsp;{"[Luke\u00A0Frydrych]"}</span>
                        </h1>
                    </div>
                    <div>
                        <small>
                            Indie
                            <ul>
                                <li className="role-dot">
                                    <span>&#9898;</span>
                                </li>
                                <li>game</li>
                                <li className="role-dot">
                                    <span>&#9898;</span>
                                </li>
                                <li>app</li>
                                <li className="role-dot">
                                    <span>&#9898;</span>
                                </li>
                                <li>web</li>
                            </ul>
                            developer
                        </small>
                    </div>
                    <div>
                        <div>
                            <b>Hey!</b> I'm a creative programmer from Poland,
                            turning ideas into digital work
                            <br />
                            Passionate about crafting precise and high-quality projects.
                            <br />
                            <br />
                            <div className="critical-build-projects-text-block">
                                My projects are built in
                                <div className="critical-build-projects">
                                    <span>Unreal&nbsp;Engine</span>{" "}
                                    <span>Android&nbsp;Studio</span>{" "}
                                    <span>2D&nbsp;Graphics&nbsp;Software</span>{" "}
                                    <span>3D&nbsp;Graphics&nbsp;Software</span>{" "}
                                    <span>Audio&nbsp;&&nbsp;Video&nbsp;Editing&nbsp;Software</span>
                                    <div>&ensp;&&nbsp;various&nbsp;<span>IDEs</span></div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                    <div>
                        <p className="critical-programming-languages">
                            I develop in&ensp;
                            <span>C++</span> <span>C#</span>{" "}
                            <span>TypeScript</span>{" "}
                            <span>React</span>{" "}
                            <span>SQL</span>{" "}
                            <span>Python</span>{" "}
                            <span>Lua</span>
                            <span>Java</span>
                            &nbsp;&&nbsp;
                            <span>Kotlin</span>
                        </p>
                        <br />
                        <br />
                    </div>
                    <div>
                        <p>
                            Interested in working together?{" "}
                            <b>Feel&nbsp;free&nbsp;to&nbsp;reach&nbsp;out!</b>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CriticalAbout;
